import { CouponType } from 'src/app/interfaces/Coupon.enum';

const eligibleTypes = [CouponType.FREE_EVENT, CouponType.VIP];

export function isEligibleForFreeEvent(discountType: CouponType): boolean {
  return eligibleTypes.includes(discountType);
}
